import React from 'react';
import { Body } from '@app/sellers/style';
import Skeleton from 'react-loading-skeleton';

const SellerProducts = () => {
  return (
    <Body>
      <div className="card">
        <Skeleton className="skeleton_img" />

        <div
          className="card-content"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <Skeleton width={100} />
          <Skeleton width={150} style={{ marginBottom: '1px' }} />

          <Skeleton width={250} style={{ marginBottom: '1px' }} />
        </div>
      </div>
    </Body>
  );
};

export default SellerProducts;
